/*!

=========================================================
* Black Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// reactstrap components
import {
  Button,
  Modal,
  ModalBody,
  FormGroup,
  Input,
  Label
} from "reactstrap";
import Select from "react-select";
//redux components
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// actions
import { 
  fetchAddModel
} from "../../actions/model_actions";

let options = [
    { value: "white_box", label: "Whitebox" },
    { value: "black_box", label: "Blackbox" }
  ]

class ModelRegisterModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        model_id: "",
        model_idState: "",
        model_name: "",
        model_nameState: "",
        userFullName: "",
        userFullNameState: "",
        description: "",
        descriptionState: "",
        modelUrl: "",
        modelUrlState: "",
        model_type: ""
    };
  }

  componentDidMount() {
    const {  } = this.props;
  }

  componentDidUpdate(prevProps, prevState) {
    const { user } = this.props;
  }

  verifyEmail = value => {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  };
  // function that verifies if a string has a given length or not
  verifyLength = (value, length) => {
    if (value.length >= length) {
      return true;
    }
    return false;
  };

  verifyUserId = value => {
    this.setState({userId_isValidated: false})
    var emailRex = /^([a-z]+[0-9]*)+(-[a-z]+[0-9]*)*$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  };

  change = (event, stateName, type, stateNameEqualTo) => {
    switch (type) {
      case "email":
        if (this.verifyEmail(event.target.value)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
        }
        break;
      case "length":
        if (this.verifyLength(event.target.value, stateNameEqualTo)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
        }
        break;
      case "userId":
        if (this.verifyUserId(event.target.value, stateNameEqualTo)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger"});
        }
        break;
      default:
        break;
    }
    this.setState({ [stateName]: event.target.value });
  };

  toggleModalAddModel = (user) => {
    const { fetchAddModel, userView } = this.props;
    const { model_id, model_name, description, model_type, modelUrl } = this.state;
    const idToken = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    // console.log(userView)
    let userModelsObj = {
      token: idToken,
      client_id: userView._id,
      model_id: model_id,
      model_name: model_name,
      description: description,
      model_type: model_type,
      model_url: modelUrl
    };
    fetchAddModel(userModelsObj);
    
    this.setState({
      model_id: "",
      model_name: "",
      description: "",
      model_type: "",
      extra_info: "",
      plot_conf: "",
      background_image: ""
    });
    this.props.handleAddModelModal();
  };

  render() {
    const {
        model_id,
        model_idState, 
        userFullName,
        userFullNameState, 
        model_name,
        model_nameState,
        description,
        descriptionState,
        modelUrl,
        modelUrlState,
        model_type
    } = this.state;
    const { addModel, handleAddModelModal } = this.props;
    // console.log(user);
    return (
      <>
        <Modal
            isOpen={addModel}
            toggle={handleAddModelModal}
            size="md"
        >
            <div className="modal-header" style={{justifyContent: 'center'}}>
                <h4 className="title title-up">
                    Model Register
                </h4>
            </div>
            <ModalBody>
                <FormGroup className={`has-label ${model_idState}`}>
                    <label>Model Id *</label>
                    <Input
                        name="model_id"
                        type="text"
                        onChange={e =>
                            this.change(e, "model_id", "userId", 1)
                        }
                        style={{color: "#000"}}
                        bsSize="md"
                    />
                    {model_idState === "has-danger" ? (
                        <label className="error">This field is required.</label>
                    ) : null}
                </FormGroup>
                <FormGroup className={`has-label ${model_nameState}`}>
                    <label>Model Name *</label>
                    <Input
                        name="model_name"
                        type="text"
                        onChange={e =>
                            this.change(e, "model_name", "length", 1)
                        }
                        style={{color: "#000"}}
                        bsSize="md"
                    />
                    {model_nameState === "has-danger" ? (
                        <label className="error">This field is required.</label>
                    ) : null}
                </FormGroup>
                <FormGroup className={`has-label ${descriptionState}`}>
                    <label>Description *</label>
                    <Input
                        name="description"
                        type="text"
                        onChange={e =>
                            this.change(e, "description", "length", 1)
                        }
                        style={{color: "#000"}}
                        bsSize="md"
                    />
                    {descriptionState === "has-danger" ? (
                        <label className="error">This field is required.</label>
                    ) : null}
                </FormGroup>
                <FormGroup className={`has-label ${modelUrlState}`}>
                    <label>Model Url *</label>
                    <Input
                        name="modelUrl"
                        type="text"
                        onChange={e =>
                            this.change(e, "modelUrl", "length", 1)
                        }
                        style={{color: "#000"}}
                        bsSize="md"
                    />
                    {modelUrlState === "has-danger" ? (
                        <label className="error">This field is required.</label>
                    ) : null}
                </FormGroup>
                <FormGroup className={`has-label ${userFullNameState}`}>
                    <label>Model Type *</label>
                    <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="singleSelect"
                        value={this.state.singleSelect}
                        onChange={value =>
                            this.setState({ model_type: value.value })
                        }
                        options={options}
                        placeholder="Model Type"
                        style={{maxHeight: "25px"}}
                    />
                </FormGroup>
            </ModalBody>
            <div className="modal-footer justify-content-center">
                <Button
                    className="btn-round"
                    color="info"
                    data-dismiss="modal"
                    type="button"
                    onClick={this.toggleModalAddModel}
                    disabled={
                        model_idState === "has-danger" ||
                        model_id === "" || 
                        model_nameState === "has-danger" || 
                        model_name === "" ||
                        descriptionState === "has-danger" ||
                        description === "" ||
                        modelUrlState === "has-danger" ||
                        modelUrl === "" || 
                        model_type === "" ? true : false
                    }
                >
                    Create New Model
                </Button>
            </div>
        </Modal>
      </>
    );
  }
}

function mapStateToProps({model, auth, user}){
  return{
      model,
      auth,
      user
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators(
      { fetchAddModel }, dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(ModelRegisterModal);